import Cookie from 'js-cookie'

export const removeLocalItem = (keys) => {
  for (const key of keys) {
    localStorage.removeItem(key)
  }
}

export const setSessionItem = (items) => {
  for (let key in items) {
    const value = items[key]
    if (typeof value === 'string') {
      sessionStorage.setItem(key, value)
    } else {
      sessionStorage.setItem(key, JSON.stringify(value))
    }
  }
}

export const getSessionItem = (key, defaultValue = null) => {
  return sessionStorage.getItem(key) || defaultValue
}

export const removeSessionItem = (keys) => {
  for (const key of keys) {
    sessionStorage.removeItem(key)
  }
}

export const clearSession = () => {
  sessionStorage.clear()
}

/**
 * Set a cookie
 * @param {object} items - key is the cookie name, if the value is an object, it is JSON stringified
 * @param {Number} [expires] - default 3650
 */
export const setCookie = (items, expires = 365 * 10) => {
  for (const key in items) {
    const val = typeof items[key] === 'object' ? JSON.stringify(items[key]) : items[key]
    Cookie.set(key, val, { secure: true, expires })
  }
}

export const deleteCookie = (key) => {
  Cookie.remove(key, { path: '/' })
}

export const deleteAllCookies = () => {
  const cookies = Cookie.get()
  for (const cookie of Object.keys(cookies)) {
    deleteCookie(cookie)
  }
}

export const getCookie = (name) => {
  return Cookie.get(name)
}

export const getJSONCookie = (name) => {
  const raw = Cookie.get(name)
  if (!raw) {
    return null
  }
  try {
    const cookie = JSON.parse(raw)
    return cookie
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`Cookie [${name}] was not parseable`, e)
    return null
  }
}
